export const ADD_CATEGORY = 'ADD_CATEGORY';
